import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import NoSearchResult from "../../../../components/Common/NoSearchResult";
import type { TableColumn } from "./types";

interface StatsTableCardProps<T> {
  title: string;
  rows: T[];
  columns: Array<TableColumn<T>>;
}

const StatsTableCard = <T,>({ title, rows, columns }: StatsTableCardProps<T>) => {
  return (
    <Card>
      <CardHeader>
        <h4 className="card-title mb-0">{title}</h4>
      </CardHeader>
      <CardBody>
        {rows.length === 0 ? (
          <NoSearchResult text="No data" />
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead>
                <tr>
                  {columns.map((column) => (
                    <th
                      key={column.label}
                      className={column.align === "end" ? "text-end" : undefined}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    {columns.map((column) => (
                      <td
                        key={column.label}
                        className={column.align === "end" ? "text-end" : undefined}
                      >
                        {column.render(row, index)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default StatsTableCard;
